

export const debounce = (func, wait, immediate) => {
	var timeout

	return function() {
		var context = this, args = arguments
		var later = function() {
			timeout = null
			if (!immediate) func.apply(context, args)
		}

		var callNow = immediate && !timeout

		clearTimeout(timeout)
		timeout = setTimeout(later, wait)

		if (callNow) func.apply(context, args)
	}
}

export const hash = (str) => {
  var hash = 0, i, chr

  if (str.length === 0) return hash

  for (i = 0; i < str.length; i++) {
    chr   = str.charCodeAt(i)
    hash  = ((hash << 5) - hash) + chr
    hash |= 0 // Convert to 32bit integer
  }

  return hash
}

export const clone = (obj) => {
	return JSON.parse(JSON.stringify(obj))
}


export const htmlDecode = (input) => {
  var e = document.createElement('textarea');
  e.innerHTML = input;
  // handle case of empty input
  return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
}

/**
  This handles a weird edge case caused by the theme editor.
  When customizing a theme, for some reason HTML comments are injected
  into templates, breaking the response data. This means we need to
  remove the comments and parse it back into JSON format, allowing for
  the data to load properly when the theme editor is open.

  @param data The response to check.
*/
export const parseDataForEditor = data => {

  if(typeof data === 'string') {
    let parsed = data.replace(/<!--[\s\S]*?-->/g, '')

    try {
      return JSON.parse(parsed)
    } catch (error) {
      console.error('Could not parse data:', data)
      return
    }
  }

  return data
}

export const getAbsoluteHeight = el => {
  // Get the DOM Node if you pass in a string
  el = (typeof el === 'string') ? document.querySelector(el) : el;

  var styles = window.getComputedStyle(el);
  var margin = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);

  return Math.ceil(el.offsetHeight + margin);
}

export const uniqueId = function () {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return '_' + Math.random().toString(36).substr(2, 9);
}

// accepts default Shopify image URL, returns image URL formatted to size
// if URL is a jpg, returns URL at formatted size as a pjpg
// if URL is a png, returns URL at formatted size as a png
// URL must be a string, size should be a number
export const imageFilter = (url, size) => {
  if (url.includes('.jpg')) {
    let splitUrl = url.split('.jpg')
    splitUrl[0] = splitUrl[0] + `_${size}x`
    let joinedUrl = splitUrl.join('.progressive.jpg')
    return joinedUrl
  }
  if (url.includes('.png')) {
    let splitUrl = url.split('.png')
    splitUrl[0] = splitUrl[0] + `_${size}x`
    let joinedUrl = splitUrl.join('.png')
    return joinedUrl
  }
}

// strips special parameters from UpWest product image alt tags
export const stripParams = (altTag) => {
  if (altTag.includes('::')) {
    let splitAltTag = altTag.split('::')
    return splitAltTag[1]
  }
  else {
    return altTag
  }
}